import React, { useMemo } from 'react'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'
import {
  FormFieldInterface,
  FormInterface,
} from 'src/shared/types/entities/form-interface'
import { FormBaseFieldSubentity } from './form-base-field-subentity'
import { FormCountryFieldSubentity } from './form-country-field-subentity'
import { FormEmailFieldSubentity } from './form-email-field-subentity'
import { FormPhoneNumberFieldSubentity } from './form-phone-number-field-subentity'

interface FormFieldSubentityProps {
  formEntity: FormInterface
  fieldSubentity: FormFieldInterface
}

export const FormFieldSubentity = ({
  formEntity,
  fieldSubentity,
}: FormFieldSubentityProps) => {
  const fieldWithCommonProps = useMemo(
    () => ({
      ...fieldSubentity,
      ...formEntity.fieldsCommonStyles,
    }),
    [fieldSubentity, formEntity.fieldsCommonStyles],
  )
  switch (fieldSubentity.slug) {
    case ContactSlugEnum.Email:
      return <FormEmailFieldSubentity fieldSubentity={fieldWithCommonProps} />
    case ContactSlugEnum.Country:
      return <FormCountryFieldSubentity fieldSubentity={fieldWithCommonProps} />
    case ContactSlugEnum.PhoneNumber:
      return (
        <FormPhoneNumberFieldSubentity fieldSubentity={fieldWithCommonProps} />
      )
    default:
      return <FormBaseFieldSubentity fieldSubentity={fieldWithCommonProps} />
  }
}
